import { render, staticRenderFns } from "./EditableItem.vue?vue&type=template&id=092bfbf2&"
import script from "./EditableItem.vue?vue&type=script&lang=js&"
export * from "./EditableItem.vue?vue&type=script&lang=js&"
import style0 from "./EditableItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports